import {
  GET_DELIVERY_CHARGES_SLABS_REQUEST,
  GET_DELIVERY_CHARGES_SLABS_RESPONSE,
  UPDATE_DELIVERY_CHARGES_SLABS_REQUEST,
  UPDATE_DELIVERY_CHARGES_SLABS_RESPONSE,
} from "./actionTypes";

export const getDeliveryChargesSlabsRequest = () => {
  return {
    type: GET_DELIVERY_CHARGES_SLABS_REQUEST,
  };
};

export const getDeliveryChargesSlabsResponse = (apiResponse) => {
  return {
    type: GET_DELIVERY_CHARGES_SLABS_RESPONSE,
    payload: { apiResponse },
  };
};

export const updateDeliveryChargesSlabsRequest = (data) => {
  return {
    type: UPDATE_DELIVERY_CHARGES_SLABS_REQUEST,
    payload: { data },
  };
};

export const updateDeliveryChargesSlabsResponse = (apiResponse) => {
  return {
    type: UPDATE_DELIVERY_CHARGES_SLABS_RESPONSE,
    payload: { apiResponse },
  };
};
